// App-wide configuration constants

export const PERSONA_CONFIG = {
  MAX_PERSONAS: 3,
};

// Better Stack hosted status page (uptime + incident history)
export const STATUS_PAGE_URL = "https://status.erode.ai";
